import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppleLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.52-3.23 0-1.44.64-2.2.46-3.06-.4C3.79 16.17 4.36 9.02 8.93 8.76c1.28.07 2.17.72 2.91.76.78-.16 1.53-.83 2.87-.76 1.63.09 2.85.73 3.41 2.07-3.13 1.73-2.39 5.53.53 6.59-.63 1.57-1.45 3.13-2.6 3.86zM12.03 8.7c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z",
		fill: "currentColor"
	})
});
export default SvgAppleLogo;
